<template>
  <div class="tone-paragraphs-content" id="identidade-verbal-tom-titulo-carrossel-grid-paragrafos" data-search-anchor>
    <div class="tone-paragraphs-icon-wrapper">
      <div class="tone-icon-wrapper">
        <div class="tone-icon-wrapper-sec">
          <IconCheck />
          <div>
            <p class="tone-description-icon" v-html="toneParagraphsDescription1"></p>
          </div>
        </div>
        <p class="tone-description">{{ toneParagraphsDescription2 }}</p>
      </div>

      <div class="tone-icon-wrapper">
        <div class="tone-icon-wrapper-sec">
          <IconCheck />
          <div>
            <p class="tone-description-icon" v-html="toneParagraphsDescription3"></p></div>
        </div>
        <p class="tone-description">{{ toneParagraphsDescription4 }}</p>
      </div>

      <div class="tone-icon-wrapper">
        <div class="tone-icon-wrapper-sec">
          <IconCheck />
          <div>
            <p class="tone-description-icon" v-html="toneParagraphsDescription5"></p>
          </div>
        </div>
        <p class="tone-description">{{ toneParagraphsDescription6 }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import TonePageMixin from '@/mixins/tone-page-mixin'
import { TonePageStore } from '@/store/verbal-identity-page/tone-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class ToneParagraphsSection extends Mixins(TonePageMixin) {
  tonePageStore: PageStoreContract = getModule(TonePageStore, this.$store)

  get toneParagraphsDescription1(): string {
    const raw = this.getElementText(6, 1) || ''
    const texto = raw.normalize('NFC')
    const alvo = 'lugares de fala:'.normalize('NFC')
    const partes = texto.split(alvo)

    if (partes.length < 2) {
      return texto
    }
    return partes[0] + `<strong class="bold-highlight">${alvo}</strong>` + partes.slice(1).join(alvo)
  }

  get toneParagraphsDescription2(): string {
    return this.getElementText(6, 2)
  }

  get toneParagraphsDescription3(): string {
    const raw = this.getElementText(6, 3) || ''    
    const texto = raw.normalize('NFC')
    const alvo = 'tratamento em nível pessoal'.normalize('NFC')
    const partes = texto.split(alvo)

    if (partes.length < 2) {
      return texto
    }
    return partes[0] + `<strong class="bold-highlight">${alvo}</strong>` + partes.slice(1).join(alvo)
  }

  get toneParagraphsDescription4(): string {
    return this.getElementText(6, 4)
  }

  get toneParagraphsDescription5(): string {
    const raw = this.getElementText(6, 5) || ''    
    const texto = raw.replace(/\s+/g, ' ').trim()
    const alvo = 'transmitir a personalidade da Globo'    
    const regex = new RegExp(alvo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')
    const partes = texto.split(regex)    

    if (partes.length < 2) {
      return texto
    }
    return partes[0] + `<strong class="bold-highlight">${alvo}</strong>` + partes.slice(1).join(alvo)
  }

  get toneParagraphsDescription6(): string {
    return this.getElementText(6, 6)
  }

  async getTonePage(): Promise<void> {
    await this.tonePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.tonePageStore.isLoading) {
      await this.getTonePage()
    }
  }
}
</script>

<style lang="scss">
.tone-paragraphs-content {
  display: grid;
  width: 1032px;
  margin-top: 96px;
}

.tone-paragraphs-icon-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: 50% 50%;
  margin-bottom: 64px;
}

.tone-icon-wrapper-sec {
  display: flex;
}

.tone-description {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  margin-bottom: 32px;
  padding-left: 44px;
  width: 430px;
}

.tone-description-icon {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  margin-top: 0;
  padding-left: 7px;
  width: 430px;  
}

.tone-description-icon .bold-highlight {
  font-weight: 700 !important;
  font-family: InterVariableBold
}
</style>
